import { render, staticRenderFns } from "./Label.global.vue?vue&type=template&id=4b0127c0&scoped=true&lang=pug&"
import script from "./Label.global.vue?vue&type=script&lang=ts&"
export * from "./Label.global.vue?vue&type=script&lang=ts&"
import style0 from "./Label.global.vue?vue&type=style&index=0&id=4b0127c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0127c0",
  null
  
)

export default component.exports